var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBannerProp1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_971_837)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 24.666,
    width: 50,
    height: 50,
    rx: 5,
    transform: "rotate(-20.6908 9 24.666)",
    fill: "#FF9EA2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9022 52.3832C55.9022 53.1532 55.5944 53.8501 55.0961 54.3538C54.5991 54.8588 53.9115 55.1707 53.1517 55.1707H46.4426C45.9795 55.1707 45.5447 55.0551 45.1617 54.8495C44.2885 54.3832 43.6934 53.4538 43.6934 52.3832C43.6934 50.8438 44.9243 49.5957 46.4432 49.5957H53.1517C54.6706 49.5957 55.9022 50.8438 55.9022 52.3832Z",
    fill: "#FFEBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1974 49.5957C50.0426 49.8526 49.8564 50.092 49.6412 50.3107L45.1627 54.8495C44.2895 54.3832 43.6943 53.4538 43.6943 52.3832C43.6943 50.8438 44.9253 49.5957 46.4442 49.5957H50.1981H50.1974Z",
    fill: "#FFDBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1521 55.1701H49.7979V49.5957H53.1521C54.5982 49.5957 55.7829 50.7263 55.8939 52.1626C55.8995 52.2357 55.9026 52.3095 55.9026 52.3826C55.9026 52.517 55.8933 52.6495 55.8748 52.7795C55.7891 53.3901 55.5079 53.9376 55.0972 54.3538C54.5995 54.8582 53.9125 55.1701 53.1527 55.1701H53.1521Z",
    fill: "#FF407E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1786 51.522H51.1638C50.9029 51.522 50.6914 51.3076 50.6914 51.0432C50.6914 50.7788 50.9029 50.5645 51.1638 50.5645H53.1786C53.4394 50.5645 53.651 50.7788 53.651 51.0432C53.651 51.3076 53.4394 51.522 53.1786 51.522Z",
    fill: "#6CBEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4226 52.8618H51.1648C50.9039 52.8618 50.6924 52.6474 50.6924 52.383C50.6924 52.1187 50.9039 51.9043 51.1648 51.9043H51.4226C51.6834 51.9043 51.8949 52.1187 51.8949 52.383C51.8949 52.6474 51.6834 52.8618 51.4226 52.8618Z",
    fill: "#6CBEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5242 35.4449V52.5168C44.5242 53.7718 43.5202 54.7893 42.2813 54.7893H28.1453C26.9069 54.7893 25.9023 53.7718 25.9023 52.5168V35.4449C25.9023 34.663 26.3044 33.9449 26.952 33.5205C28.0343 32.8105 28.6103 31.8474 28.9131 30.9499C29.2122 30.0636 29.243 29.2399 29.2307 28.7861H41.1959C41.1836 29.2399 41.2144 30.0636 41.5135 30.9499C41.8157 31.8474 42.3923 32.8111 43.4746 33.5205C44.1221 33.9449 44.5242 34.663 44.5242 35.4449Z",
    fill: "#20CFA2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5238 44.6696V52.5177C44.5238 53.7727 43.5198 54.7902 42.2809 54.7902H39.2578C38.0781 53.2864 38.1737 51.0852 39.5458 49.6952L44.2895 44.8877C44.3653 44.8108 44.443 44.7383 44.5238 44.6689V44.6696Z",
    fill: "#239797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9131 30.9499C29.2122 30.0636 29.243 29.2399 29.2307 28.7861H41.1959C41.1836 29.2399 41.2144 30.0636 41.5135 30.9499H28.9131Z",
    fill: "#239797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5241 35.4455V52.5174C44.5241 53.7074 43.6219 54.6843 42.4724 54.7818C42.9713 54.3649 43.2895 53.7343 43.2895 53.0274V35.9555C43.2895 35.1736 42.8874 34.4561 42.2399 34.0311C40.0894 32.6205 39.9359 30.2099 39.9624 29.2961V28.7861H41.1964C41.1711 29.6999 41.3247 32.1105 43.4751 33.5211C44.1227 33.9455 44.5248 34.6636 44.5248 35.4455H44.5241Z",
    fill: "#239797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2257 29.8385H28.2001C27.922 29.8385 27.6963 29.6098 27.6963 29.3279V23.9735C27.6963 23.6916 27.922 23.4629 28.2001 23.4629H42.2257C42.5039 23.4629 42.7296 23.6916 42.7296 23.9735V29.3279C42.7296 29.6098 42.5039 29.8385 42.2257 29.8385Z",
    fill: "#FFDBB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2257 29.8386H28.2001C27.922 29.8386 27.6963 29.6099 27.6963 29.328V28.7861H42.7296V29.328C42.7296 29.6099 42.5039 29.8386 42.2257 29.8386Z",
    fill: "#FFC38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9997 30.1934C29.7389 30.1934 29.5273 29.979 29.5273 29.7146V23.6721C29.5273 23.4077 29.7389 23.1934 29.9997 23.1934C30.2606 23.1934 30.4721 23.4077 30.4721 23.6721V29.7146C30.4721 29.979 30.2606 30.1934 29.9997 30.1934Z",
    fill: "#FFC38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4753 30.1934C33.2145 30.1934 33.0029 29.979 33.0029 29.7146V23.6721C33.0029 23.4077 33.2145 23.1934 33.4753 23.1934C33.7362 23.1934 33.9477 23.4077 33.9477 23.6721V29.7146C33.9477 29.979 33.7362 30.1934 33.4753 30.1934Z",
    fill: "#FFC38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9509 30.1934C36.69 30.1934 36.4785 29.979 36.4785 29.7146V23.6721C36.4785 23.4077 36.69 23.1934 36.9509 23.1934C37.2118 23.1934 37.4233 23.4077 37.4233 23.6721V29.7146C37.4233 29.979 37.2118 30.1934 36.9509 30.1934Z",
    fill: "#FFC38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4265 30.1934C40.1656 30.1934 39.9541 29.979 39.9541 29.7146V23.6721C39.9541 23.4077 40.1656 23.1934 40.4265 23.1934C40.6874 23.1934 40.8989 23.4077 40.8989 23.6721V29.7146C40.8989 29.979 40.6874 30.1934 40.4265 30.1934Z",
    fill: "#FFC38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8783 32.5513H30.8103C30.5494 32.5513 30.3379 32.3369 30.3379 32.0725C30.3379 31.8081 30.5494 31.5938 30.8103 31.5938H35.8789C36.1398 31.5938 36.3513 31.8081 36.3513 32.0725C36.3513 32.3369 36.1398 32.5513 35.8789 32.5513H35.8783Z",
    fill: "#B5F2D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4676 32.5513H37.4402C37.1793 32.5513 36.9678 32.3369 36.9678 32.0725C36.9678 31.8081 37.1793 31.5938 37.4402 31.5938H38.4676C38.7285 31.5938 38.94 31.8081 38.94 32.0725C38.94 32.3369 38.7285 32.5513 38.4676 32.5513Z",
    fill: "#B5F2D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2108 49.5848H29.2148C28.9366 49.5848 28.7109 49.356 28.7109 49.0741V38.911C28.7109 38.6291 28.9366 38.4004 29.2148 38.4004H41.2108C41.489 38.4004 41.7147 38.6291 41.7147 38.911V49.0735C41.7147 49.3554 41.489 49.5841 41.2108 49.5841V49.5848Z",
    fill: "#FFEBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7147 46.4902V49.0746C41.7147 49.3565 41.489 49.5852 41.2108 49.5852H29.2148C28.9366 49.5852 28.7109 49.3565 28.7109 49.0746V46.4902H41.7153H41.7147Z",
    fill: "#FFC38B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7147 47.4967V49.0742C41.7147 49.3561 41.489 49.5848 41.2108 49.5848H39.6543L41.7153 47.4961L41.7147 47.4967Z",
    fill: "#E4A162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2609 48.5161H33.1648C32.9039 48.5161 32.6924 48.3017 32.6924 48.0373C32.6924 47.773 32.9039 47.5586 33.1648 47.5586H37.2609C37.5218 47.5586 37.7333 47.773 37.7333 48.0373C37.7333 48.3017 37.5218 48.5161 37.2609 48.5161Z",
    fill: "#B5F2D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5573 41.0288H30.9255C30.6647 41.0288 30.4531 40.8144 30.4531 40.55C30.4531 40.2857 30.6647 40.0713 30.9255 40.0713H32.5579C32.8188 40.0713 33.0303 40.2857 33.0303 40.55C33.0303 40.8144 32.8188 41.0288 32.5579 41.0288H32.5573Z",
    fill: "#E4A162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4746 43.2124H30.9245C30.6637 43.2124 30.4521 42.998 30.4521 42.7336C30.4521 42.4693 30.6637 42.2549 30.9245 42.2549H31.4746C31.7355 42.2549 31.947 42.4693 31.947 42.7336C31.947 42.998 31.7355 43.2124 31.4746 43.2124Z",
    fill: "#E4A162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4746 44.8198H30.9245C30.6637 44.8198 30.4521 44.6054 30.4521 44.3411C30.4521 44.0767 30.6637 43.8623 30.9245 43.8623H31.4746C31.7355 43.8623 31.947 44.0767 31.947 44.3411C31.947 44.6054 31.7355 44.8198 31.4746 44.8198Z",
    fill: "#E4A162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.235 43.2124H34.9021C34.6412 43.2124 34.4297 42.998 34.4297 42.7336C34.4297 42.4693 34.6412 42.2549 34.9021 42.2549H39.235C39.4959 42.2549 39.7074 42.4693 39.7074 42.7336C39.7074 42.998 39.4959 43.2124 39.235 43.2124Z",
    fill: "#E4A162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.235 44.8198H34.9021C34.6412 44.8198 34.4297 44.6054 34.4297 44.3411C34.4297 44.0767 34.6412 43.8623 34.9021 43.8623H39.235C39.4959 43.8623 39.7074 44.0767 39.7074 44.3411C39.7074 44.6054 39.4959 44.8198 39.235 44.8198Z",
    fill: "#E4A162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9096 49.57L44.1659 54.3775C43.0923 55.4656 41.3507 55.4656 40.2764 54.3775C39.2021 53.2893 39.2021 51.5243 40.2764 50.4356L45.0201 45.6281C46.0944 44.5393 47.8353 44.5393 48.9096 45.6281C49.4468 46.1725 49.715 46.8856 49.715 47.5993C49.715 48.3125 49.4468 49.0262 48.9096 49.57Z",
    fill: "#FFEBDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9098 49.5699L46.538 51.9736L42.6484 48.0318L45.0203 45.628C46.0428 44.5918 47.6696 44.5418 48.7501 45.4786C48.805 45.5268 48.8586 45.5761 48.9098 45.628C49.0035 45.723 49.0899 45.8236 49.167 45.9286C49.5327 46.4224 49.7152 47.0105 49.7152 47.5993C49.7152 48.3124 49.4469 49.0255 48.9098 49.5699Z",
    fill: "#6CBEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6259 48.5551C44.505 48.5551 44.3841 48.5082 44.2916 48.4151C44.1072 48.2282 44.1072 47.9251 44.2916 47.7382L45.7162 46.2945C45.9006 46.1076 46.1997 46.1076 46.3841 46.2945C46.5685 46.4813 46.5685 46.7845 46.3841 46.9713L44.9595 48.4151C44.867 48.5082 44.7461 48.5551 44.6253 48.5551H44.6259Z",
    fill: "#FF407E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5604 49.5018C45.4396 49.5018 45.3187 49.4549 45.2262 49.3618C45.0418 49.1749 45.0418 48.8718 45.2262 48.6849L45.4081 48.5005C45.5925 48.3136 45.8916 48.3136 46.076 48.5005C46.2604 48.6874 46.2604 48.9905 46.076 49.1774L45.8941 49.3618C45.8016 49.4555 45.6807 49.5018 45.5598 49.5018H45.5604Z",
    fill: "#FF407E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_971_837",
    x: 0.442383,
    y: 0.442383,
    width: 81.5557,
    height: 81.5557,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_971_837"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_971_837",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 32,
    fill: "white",
    transform: "translate(25.9023 23.1934)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerProp1);
export default __webpack_public_path__ + "static/media/BannerProp_1.ba74d6dfe429b705ac32cc5716bc467e.svg";
export { ForwardRef as ReactComponent };